import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Checkout.css";
import Header from "./Header";

function Checkout() {
    const navigate = useNavigate();
    const location = useLocation();
    const { cartItems = [] } = location.state || {};

    // Calculate total price within the component
    const totalPrice = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);

    return (
        <>
            <Header />
            <div className="checkout-container">
                <div className="back-button-container">
                    <button className="back-button" onClick={() => navigate(-1)}>
                        ⬅️ Back
                    </button>
                </div>

                <h2>Checkout</h2>

                {cartItems.length === 0 ? (
                    <h2>Your cart is empty. Please add items before checkout.</h2>
                ) : (
                    <>
                        <div className="order-summary">
                            <h3>Order Summary</h3>
                            {cartItems.map((item, index) => (
                                <div key={index} className="checkout-item">
                                    <span>
                                        {item.product_name} (x{item.quantity})
                                    </span>
                                    <span>₹{(item.price * item.quantity).toFixed(2)}</span>
                                </div>
                            ))}
                            <div className="total-amount">
                                <strong>Total: ₹{totalPrice.toFixed(2)}</strong>
                            </div>
                        </div>
                        <button
    className="view-orders-button"
    onClick={() => navigate('/Orders')}
>
    Click to View Orders
</button>
                    </>
                )}
            </div>
        </>
    );
}

export default Checkout;